import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-836bf494"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "marcas-container" };
const _hoisted_2 = { class: "dashboard" };
const _hoisted_3 = { class: "marcas-content" };
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h1", { class: "title" }, "Ordenar Desplegables", -1 /* HOISTED */));
const _hoisted_5 = { class: "col-3" };
const _hoisted_6 = { class: "form-group" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "repuestos" }, "Repuesto:", -1 /* HOISTED */));
const _hoisted_8 = { class: "autocomplete" };
const _hoisted_9 = {
    key: 0,
    class: "autocomplete-list"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "marcas-table" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", null, "Nombre Atributo"),
        /*#__PURE__*/ _createElementVNode("th", null, "Orden")
    ])
], -1 /* HOISTED */));
const _hoisted_13 = { id: "sortable" };
const _hoisted_14 = {
    key: 0,
    class: "modal"
};
const _hoisted_15 = { class: "modal-content" };
const _hoisted_16 = { id: "sortable-values" };
const _hoisted_17 = { class: "modal-actions" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Header = _resolveComponent("Header");
    const _component_Sidebar = _resolveComponent("Sidebar");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" Header "),
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_2, [
            _createCommentVNode(" Sidebar "),
            _createVNode(_component_Sidebar),
            _createCommentVNode(" Main Content "),
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createCommentVNode(" Buscar repuesto "),
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createElementVNode("div", _hoisted_8, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.searchRepuestos) = $event)),
                                onInput: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    (...args) => ($setup.searchRepuesto && $setup.searchRepuesto(...args))),
                                placeholder: "Buscar repuesto..."
                            }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                [_vModelText, $setup.searchRepuestos]
                            ]),
                            ($setup.filteredRepuestos.length > 0 && $setup.searchRepuestos.length >= 3)
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredRepuestos, (repuesto) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: repuesto.repuestoID,
                                            onClick: ($event) => ($setup.selectRepuesto(repuesto))
                                        }, _toDisplayString(repuesto.nombre), 9 /* TEXT, PROPS */, _hoisted_10));
                                    }), 128 /* KEYED_FRAGMENT */))
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ]),
                _createCommentVNode(" Tabla de desplegables "),
                _createElementVNode("table", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("tbody", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.desplegables, (desplegable) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: desplegable.atributoID,
                                class: "sortable-item"
                            }, [
                                _createElementVNode("td", null, _toDisplayString(desplegable.nombreAtributo.nombreAtributo), 1 /* TEXT */),
                                _createElementVNode("td", null, _toDisplayString(desplegable.orden), 1 /* TEXT */)
                            ]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ])
                ]),
                _createCommentVNode(" Modal para Ordenar Valores "),
                ($setup.isModalOpen)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h2", null, "Ordenar Valores de " + _toDisplayString($setup.currentDesplegable.nombreAtributo.nombreAtributo), 1 /* TEXT */),
                            _createElementVNode("ul", _hoisted_16, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.valores, (valor) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                        key: valor.valorID,
                                        class: "sortable-item"
                                    }, _toDisplayString(valor.nombre), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("button", {
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => ($setup.saveValoresOrder && $setup.saveValoresOrder(...args))),
                                    class: "btn-save"
                                }, "Guardar"),
                                _createElementVNode("button", {
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => ($setup.closeModal && $setup.closeModal(...args))),
                                    class: "btn-cancel"
                                }, "Cerrar")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ])
        ])
    ]));
}
